export default __webpack_public_path__ + "static/industry-bw-b6e87b8ed5e53e192b615ef045bc9a27.jpeg";